var data = {
	"body": "<path fill=\"currentColor\" d=\"M18 21H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3zM6 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
